@import 'styles/variables';
@import 'styles/mixins';

.card3d {
  width: 181px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: var(---light-100);
  overflow: hidden;
  box-shadow: 0 0 6px 0 rgba(22, 27, 29, 0.15);

  &:hover {
    z-index: 10;
  }
}
